import { VRATI_DOKUMENT, UKLONI_DOKUMENT } from "../actions/types";

const initialState = {
  dokument: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case VRATI_DOKUMENT:
      return {
        ...state,
        dokument: action.payload
      };
    case UKLONI_DOKUMENT:
      return {
        ...state,
        dokument: action.payload
      };

    default:
      return state;
  }
}
